import React from 'react';
import { Card, CardContent } from './ui/card';
import { Truck, Clock, DollarSign, Award, Wrench, FileText } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const iconMap = {
  Truck,
  Clock,
  DollarSign,
  Award,
  Wrench,
  FileText
};

const WhyChooseUs = () => {
  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            The Cooper Equipment Rentals Advantage
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another rental company. We're your partner in getting the job done right.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((item, index) => {
            const Icon = iconMap[item.icon];
            return (
              <Card 
                key={index}
                className="border-2 hover:border-orange-600 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <CardContent className="p-6">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                        <Icon className="w-6 h-6 text-orange-600" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-600 mb-2">600+</div>
            <div className="text-gray-600 font-medium">Units in Our Fleet</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-600 mb-2">25+</div>
            <div className="text-gray-600 font-medium">Years in Business</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-600 mb-2">100%</div>
            <div className="text-gray-600 font-medium">Final Pricing. No Add-ons. No surprises.</div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-600 mb-2">On-Time</div>
            <div className="text-gray-600 font-medium">Jobsite Delivery</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
